import { createFileRoute } from '@tanstack/react-router'
import { FindOffersDialogPending } from '@/routes/_app/-components/shared/dialog-pending'
import { useModalSlot } from '@/components/custom/modal-slot'
import FindOffersDialog from '@/routes/_app/-dialogs/find-offers'

export const Route = createFileRoute('/@modal/offers/find')({
  staticData: { slotScope: '/_app/offers/_list' },
  pendingComponent: FindOffersDialogPending,
  component: FindOffersSlot,
})

function FindOffersSlot() {
  const slot = useModalSlot(Route)
  return <FindOffersDialog {...slot} />
}
